import api from './api';
import { handleResponse, handleError } from './api';

/**
 * Give/Take board API. A board is scoped by `context`:
 *   "portal"    — standalone, geo-filtered to a 50mi radius of the viewer.
 *   "event"     — that event's guests (pass eventId).
 *   "gathering" — that gathering's members (pass gatheringId).
 *
 * Claiming a post opens a 1:1 chat and returns its threadId.
 */
const giveTakeService = {
  async getBoard({ context = 'portal', eventId = null, gatheringId = null, localOnly = false } = {}) {
    try {
      const params = new URLSearchParams({ context });
      if (eventId) params.set('eventId', eventId);
      if (gatheringId) params.set('gatheringId', gatheringId);
      if (localOnly) params.set('localOnly', 'true');
      return handleResponse(await api.get(`/give-take?${params.toString()}`));
    } catch (e) { return handleError(e); }
  },

  async createPost({ context = 'portal', eventId = null, gatheringId = null, kind, title, note = null }) {
    try {
      return handleResponse(await api.post('/give-take', { context, eventId, gatheringId, kind, title, note }));
    } catch (e) { return handleError(e); }
  },

  async updatePost(id, { title, note = null }) {
    try { return handleResponse(await api.put(`/give-take/${id}`, { title, note })); }
    catch (e) { return handleError(e); }
  },

  async deletePost(id) {
    try { return handleResponse(await api.delete(`/give-take/${id}`)); }
    catch (e) { return handleError(e); }
  },

  async claimPost(id) {
    try { return handleResponse(await api.post(`/give-take/${id}/claim`)); }
    catch (e) { return handleError(e); }
  },

  async unclaimPost(id) {
    try { return handleResponse(await api.post(`/give-take/${id}/unclaim`)); }
    catch (e) { return handleError(e); }
  },
};

export default giveTakeService;
